//use bulma
import 'bulma/css/bulma.min.css';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
    alertType: string;
    alertTitle: string;
    alertMessage: string;
    closeAlertModal: any;
    deleteAlertModal: any;
}

function AlertDialog(props: Props) {

    const dialogStyle = {

        footerStyle: {
            justifyContent: "flex-end"
        }
    };

    function displayAlertMesageHtml(type: string) {
        switch (type) {
            case "is-danger":
                return (<section className="modal-card-body is-flex">
                    <div className="media">
                        <div className="media-left">
                            <span className="icon has-text-danger is-size-3">
                                <FontAwesomeIcon icon={["fas", "exclamation-circle"]} />
                            </span>
                        </div>
                        <div className="media-content">
                            <p>{props.alertMessage}</p>
                        </div>
                    </div>
                </section>);
            case "is-success":
                return (<section className="modal-card-body is-flex">
                    <div className="media">
                        <div className="media-left">
                            <span className="icon has-text-success is-size-3">
                                <FontAwesomeIcon icon={["far", "circle-check"]} />
                            </span>
                        </div>
                        <div className="media-content">
                            <p>{props.alertMessage}</p>
                        </div>
                    </div>
                </section>);
            case "is-warning":
                return (<section className="modal-card-body is-flex">
                    <div className="media">
                        <div className="media-left">
                            <span className="icon has-text-warning is-size-3">
                                <FontAwesomeIcon icon={["fas", "exclamation-circle"]} />
                            </span>
                        </div>
                        <div className="media-content">
                            <p>{props.alertMessage}</p>
                        </div>
                    </div>
                </section>);
        }
    }

    function displayFooterButtons(type: string) {
        if (type == 'is-warning') {
            return (
                <footer className="modal-card-foot" style={dialogStyle.footerStyle}>
                    <button className={`button ${props.alertType}`} onClick={props.closeAlertModal}>Cancel</button>
                    <button className="button is-danger" onClick={props.deleteAlertModal}>Delete</button>
                </footer>)
        }
        return (
            <footer className="modal-card-foot" style={dialogStyle.footerStyle}>
                <div className="buttons">
                    <button className={`button ${props.alertType}`} onClick={props.closeAlertModal}>OK</button>
                </div>
        </footer>)
    }

    return (
        <>
            <div className="modal-background"></div>
            <div className="modal-card animation-content">
                <header className="modal-card-head">
                    <p className="modal-card-title">{props.alertTitle}</p>
                </header>
                {displayAlertMesageHtml(props.alertType)}
                {displayFooterButtons(props.alertType)}
            </div>
        </>
    );
}

export default AlertDialog;